<template>
  <div :class="classes">
    <pt-page-title title="视频详情"></pt-page-title>
    <div v-if="videoValue">
      <pt-sub-title title="视频信息"></pt-sub-title>
      <pt-form-item class="special" label="视频名称：" :labelWidth="labelWidth" :lineHeight="lineHeight">
        <span>{{videoValue.name}}</span>
      </pt-form-item>
      <pt-form-item class="special" label="视频封面图：" :labelWidth="labelWidth" v-if="videoValue.imageUrl"
        :lineHeight="lineHeight">
        <pt-img :src="$publicResourcesUrl + videoValue.imageUrl" :isPublic="true" class="quaImages"></pt-img>
      </pt-form-item>
      <pt-form-item class="special" label="录制时间：" :labelWidth="labelWidth" :lineHeight="lineHeight">
        <span>{{videoValue.recordingTime_copy}}</span>
      </pt-form-item>
      <pt-form-item class="special" label="上传日期：" :labelWidth="labelWidth" :lineHeight="lineHeight">
        <span>{{videoValue.uploadTime_copy}}</span>
      </pt-form-item>
       <pt-form-item class="special" label="视频链接：" :labelWidth="labelWidth" :lineHeight="lineHeight">
         {{$publicResourcesUrl + videoValue.contentUrl}}
        <pt-copy-button style="padding-top:0;padding-bottom:0;" type="text"
          :copyContent="$publicResourcesUrl + videoValue.contentUrl" text="点击复制"></pt-copy-button>
      </pt-form-item>
       <pt-form-item class="special" label="视频文件：" :labelWidth="labelWidth" :lineHeight="lineHeight">
         <el-button type="text" @click="toDownLoad">{{videoName}}</el-button>
      </pt-form-item>
    </div>
    <div class="marginTop">
      <el-button type="primary" @click="goEdit(videoValue)">编辑</el-button>
      <el-button type="danger" plain @click="goDelete(videoValue)">删除</el-button>
    </div>
  </div>
</template>

<script>
// 组件class前缀
const prefixCls = 'pt-previous-video-detail'

export default {
  name: 'pt-previous-video-detail',
  computed: {
    classes () {
      return `${prefixCls}`
    }
  },
  props: {
    value: {
      type: Object,
      default: () => {}
    }
  },
  watch: {
    value (val) {
      this.videoValue = val
      let s = this.videoValue && this.videoValue.contentUrl
      this.videoName = s.substring(s.lastIndexOf('/') + 1)
    }
  },
  data () {
    return {
      labelWidth: '150px',
      lineHeight: '50',
      videoValue: this.value,
      videoName: ''
    }
  },
  methods: {
    toDownLoad () {
      location.href = this.$publicResourcesUrlDownload + this.videoValue.contentUrl
    },
    goEdit (data) {
      this.$router.push('/previous-video/previous-video-form/true/' + data.id)
    },
    goDelete (row) {
      this.$emit('deleteVideo', row)
    }
  }
}
</script>

<style lang="less">
@import '~less/var.less';
  /* 已启用css module， template中请使用$style.className添加class */
  /* 务必遵循css BEM原则 */
  .pt-previous-video-detail{
  .special >span{
    color:@mainColor;
  }
  .quaImages{
    width:204px;
    height: 128px;
  }
  .pictureNames{
    display: flex;
    margin:0;
    padding-left: 0;
    li{
      width:204px;
      line-height: 20px;
      text-align: center;
    }
  }
}
</style>
